export const StatisticGroupProp = Object.freeze({
    Inverted: 'inverted',
    SegmentColor: 'segmentColor',
    Statistics: 'statistics',
    Title: 'title',
});
